import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatListModule } from '@angular/material/list';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { userServices } from 'src/app/services/users.service';
import { firstValueFrom } from 'rxjs';
import { DialogComponent } from '../../dialog/confirm.dialog';

@Component({
  selector: 'app-manage-followers-modal',
  standalone: true,
  imports: [
    CommonModule,
    MatSelectModule,
    MatFormFieldModule,
    MatListModule,
    MatChipsModule,
    MatIconModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    HttpClientModule,
    MatProgressSpinnerModule
  ],
  template: `
    <h2 mat-dialog-title>Manage Followers</h2>
<mat-dialog-content>
  <!-- Loading indicator -->
  <div *ngIf="isLoading" style="display: flex; justify-content: center; align-items: center; height: 100px;">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <!-- User selection form -->
  <div *ngIf="!isLoading">
    <!-- Display image if no users are available -->

    <!-- Display user selection form if users are available -->
    <div>
      <mat-form-field *ngIf="users?.length > 0" appearance="outline" style="margin-top: 10px">
        <mat-label>Find users</mat-label>
        <mat-select [(ngModel)]="selectedUsers" (selectionChange)="onSelectionChange($event)">
          <mat-option *ngFor="let user of users" [value]="user">{{ user?.name }} {{user?.lastName}}</mat-option>
        </mat-select>
      </mat-form-field>
        <div *ngIf="prefSelectedUsers.length>0" style="height:150px;overflow-y:scroll">
         <div style="padding: 10px;border-bottom: 1px solid var(--form-border-color, lightgray)" *ngFor="let data of prefSelectedUsers">
          <div style="display:flex;justify-content:space-between">
            <div style="color:var(--form-text-primary, #000000)">{{ data.user.name }} {{ data.user.lastName }}</div>
            <div><mat-icon style="cursor:pointer;color:var(--form-error-color, red)" (click)="removeUser(data)">delete_forever</mat-icon></div>
          </div>
        </div>
      </div>

      <div *ngIf="prefSelectedUsers?.length === 0" style="height:150px;overflow-y:scroll;text-align: center;">
          <img src="assets/images/backgrounds/user-subscribe.jpg" alt="No users available" style="max-width: 40%; height: auto;">
      <p>No users available</p>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions style="display:flex;justify-content:end">
  <button mat-button color="primary" (click)="onClose()">Close</button>
</mat-dialog-actions>
  `,
  styles: [`
    mat-form-field {
      width: 100%;
    }
    mat-list {
      margin-top: 20px;
    }

    // Dark Theme Support
    :host-context(body.dark-theme) {
      h2[mat-dialog-title] {
        color: var(--form-text-primary, #ffffff);
      }

      mat-dialog-content {
        color: var(--form-text-primary, #ffffff);

        ::ng-deep {
          .mat-mdc-form-field {
            .mdc-text-field {
              background-color: var(--form-input-bg, #2d3748);
            }

            .mdc-notched-outline__leading,
            .mdc-notched-outline__notch,
            .mdc-notched-outline__trailing {
              border-color: var(--form-input-border, #4a5568);
            }

            &.mat-focused {
              .mdc-notched-outline__leading,
              .mdc-notched-outline__notch,
              .mdc-notched-outline__trailing {
                border-color: var(--form-primary-color, #00a1ff);
              }
            }

            .mat-mdc-form-field-label,
            .mdc-floating-label,
            .mat-mdc-select-value,
            .mat-mdc-select-arrow {
              color: var(--form-text-primary, #ffffff);
            }
          }

          .mat-mdc-select-panel {
            background: var(--form-card-bg, #2b2b2b);
          }

          .mat-mdc-option {
            background: var(--form-card-bg, #2b2b2b);
            color: var(--form-text-primary, #ffffff);

            &:hover {
              background: var(--lead-hover-bg, rgba(255, 255, 255, 0.05));
            }

            &.mat-selected {
              background: rgba(0, 161, 255, 0.15);
              color: var(--form-primary-color, #00a1ff);
            }
          }

          .mat-mdc-progress-spinner {
            circle {
              stroke: var(--form-primary-color, #00a1ff);
            }
          }
        }

        // User list items
        > div > div > div {
          border-bottom-color: var(--form-border-color, #4a5568) !important;

          > div > div {
            color: var(--form-text-primary, #ffffff) !important;

            mat-icon {
              color: var(--form-error-color, #ef5350) !important;

              &:hover {
                opacity: 0.8;
              }
            }
          }
        }

        // Empty state text
        > div > div > div > p {
          color: var(--form-text-secondary, #b0b0b0);
        }

        // Scrollable container styling
        > div > div > div[style*="overflow-y:scroll"] {
          &::-webkit-scrollbar {
            width: 8px;
          }

          &::-webkit-scrollbar-track {
            background: var(--lead-scrollbar-track, #2a2a2a);
          }

          &::-webkit-scrollbar-thumb {
            background: var(--lead-scrollbar-thumb, #555555);
            border-radius: 4px;

            &:hover {
              background: var(--lead-scrollbar-thumb-hover, #666666);
            }
          }
        }
      }

      mat-dialog-actions {
        button {
          &.mat-mdc-button {
            &[color="primary"] {
              color: var(--form-primary-color, #00a1ff);

              &:hover {
                background-color: rgba(0, 161, 255, 0.08);
              }
            }
          }
        }
      }
    }
  `]
})
export class ManageFollowersModalComponent implements OnInit {
  users: any[] = []; // Users fetched from the API
  selectedUsers: any[] = []; // Selected users (leads of the current user)
  prefSelectedUsers: any[] = []
  isLoading: boolean = true; // Loading state

  constructor(
    public dialogRef: MatDialogRef<ManageFollowersModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, // Data passed to the modal (current user's leads)
    private userService: userServices,
    private dialog:MatDialog
  ) { }

  ngOnInit(): void {
    this.fetchUsers();
  }

  // Fetch users from the API
  async fetchUsers(): Promise<void> {
    this.isLoading = true; // Show loading spinner
    // Assuming `this.userService.get()` returns an Observable
    const response: any = await firstValueFrom(this.userService.useresExceptMe(this.data?.lead.id));
    this.users = response; // Update the users array with the response data
    this.prefSelectedUsers = this.data?.currentUserLeads
    this.isLoading = false
  }

  // Handle selection change
  async onSelectionChange(event: any): Promise<void> {
    const selectedUser = event.value;
    if (selectedUser) {
      const obj = {
        lead_id: this.data.lead.id,
        user_id: selectedUser.id
      }
      const response = await firstValueFrom(this.userService.updateUserFollowers(obj));

      // Remove the selected user from the list of available users
      this.users = this.users.filter(user => user.id !== selectedUser.id);

      // Add the selected user to the prefSelectedUsers list
      this.prefSelectedUsers.push(response);

      // Clear the selection
      this.selectedUsers = [];
    }
  }

  onClose(): void {
    this.dialogRef.close(this.prefSelectedUsers);
  }

  // Remove user from the prefSelectedUsers list
  async removeUser(data: any): Promise<void> {
    if (data.user_id == this.data.lead.user?.id || data.user_id == this.data.lead.secondaryUser?.id) {
      await this.callDialog('Unsubscribe Lead', `You cannot unfollow this lead because you are the owner.`, true,'warning');
      return
    }
    const isConfirmed = await this.callDialog('Unsubscribe Lead', `Are you sure you want to unsubscribe lead?`);

    if (isConfirmed) {
        await firstValueFrom(this.userService.removeUserFollowers(data.id));

        // Remove the user from the prefSelectedUsers list
        this.prefSelectedUsers = this.prefSelectedUsers.filter(lead_follow => lead_follow.id !== data.id);

        // Add the user back to the available users list
        this.users.push(data.user);
    }
  }

   callDialog(header: string, content: string,isInfo=false,type='info') {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          header,
          content,
          isInfo,
          type
        },
        width: '400px', // Optional: customize dialog size
      });
  
      return dialogRef.afterClosed().toPromise();
    }
}